export function useShowBuyNowBasedOnDeviceType(isMobile: boolean) {
  if (!isMobile) return true
  return false
}
